import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, lastValueFrom, Observable } from 'rxjs';
import { ICart, TVerifyBranchResponse } from '../models/cart.model';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  private URL: string = environment.rootUrl;
  private URL_SERVICES: string = environment.rootServicesUrl;

  constructor(
    private http: HttpClient
  ) { }

  public onGettingCartList(): Observable<ICart> {
    return this.http.get<ICart>(`${this.URL}/cart`);
  }

  public async onGettingCartListDirect(): Promise<any> {
    return this.http.get(`${this.URL}/cart`).toPromise();
  }

  public onAddingNewProduct(product: any): Promise<any> {
    try {
      return this.http.post(`${this.URL}/cart/items`, product).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public onHandlingRemoveProduct(product_id: any): Promise<any> {
    return this.http.delete(`${this.URL}/cart/items/${product_id}`).toPromise();
  }

  public onHandlingProductQuantity(product: any): Promise<any> {
    try {
      return this.http.put(`${this.URL}/cart/items/quantity`, product).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public onHandlingProductNote(product: any): Promise<any> {
    try {
      return this.http.put(`${this.URL}/cart/items/comments`, product).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public onHandlingDeleteProductNote(id: number): Promise<object> {
    return lastValueFrom(this.http.delete(`${this.URL}/cart/items/comments/${id}`));
  }

  public onHandlingProductReplacement(product: any): Promise<any> {
    try {
      return this.http.put(`${this.URL}/cart/items/replace`, product).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public onHandlingAllProductsReplacement(): Promise<any> {
    try {
      return this.http.put(`${this.URL}/cart/items/replace`, {}).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public onSettingDeliveryAddress(address: any): Promise<any> {
    return this.http.patch(`${this.URL}/cart/address/delivery`, address).toPromise();
  }

  public onSettingPickupAddress(address: any): Promise<any> {
    return this.http.patch(`${this.URL}/cart/address/pickup`, address).toPromise();
  }

  public onDeleteCartList(): Promise<any> {
    try {
      return this.http.delete(`${this.URL}/cart`).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public async setScheduleToCart(data: any): Promise<any> {
    const sendData = {
      scheduled_date: data
    };
    return this.http.patch(`${this.URL}/cart/scheduled-date`, sendData).toPromise();
  }

  public async verifyProductsOnSelectedBranch(): Promise<any> {
    return this.http.get(`${this.URL}/cart/verify-cart`).toPromise();
  }

  public applyCoupon(coupon_code: string): Promise<any> {
    return this.http.post(`${this.URL_SERVICES}/coupons/${coupon_code}/apply`, {}).toPromise();
  }

  public unapplyCoupon(coupon_code: string): Promise<any> {
    return this.http.post(`${this.URL_SERVICES}/coupons/${coupon_code}/unapply`, {}).toPromise();
  }

  public verifyBranch(branch: number): Promise<TVerifyBranchResponse> {
    return firstValueFrom(this.http.get<TVerifyBranchResponse>(`${this.URL}/cart/verify-branch?branch=${branch}`));
  }

  public returnCart(order_id: number): Promise<any> {
    return this.http.post(`${this.URL}/cart/copyOldCart`, { order_id }).toPromise();
  }
}
